<template>
  <button class="mt-3 mb-3 btn btn-sm btn-success" @click="clear_reminder()">
    Done
  </button>
</template>
<script setup>
import { defineProps, defineEmits } from "vue";

import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
const props = defineProps(["note"]);
const emits = defineEmits(["reminderCleared"]);
const clear_reminder = async () => {
  //console.log(props.note);
  const noteRef = doc(db, "notes", props.note.account_id);

  // Set the "capital" field of the city 'DC'
  await updateDoc(noteRef, {
    ["journal." + props.note.journal_id + ".r"]: "",
  });
  emits("reminderCleared");
};
</script>
